import Joi from "joi";

export const featureSchema = Joi.object({
  sName: Joi.string().trim().required().messages({
    "string.base": "Feature Name must be a string.",
    "string.empty": "Feature Name is required.",
    "any.required": "Feature Name is required.",
  }),
  sDescription: Joi.string().trim().messages({
    "string.base": "Feature Description must be a string.",
    "string.empty": "Feature Description is required.",
    "any.required": "Feature Description is required.",
  }),
  featureCategoryId: Joi.number().required().messages({
    "number.base": "Feature Category is required.",
    "any.required": "Feature Category is required.",
  }),
});
